import './ContactStyle.css';

function Contacts() {
  const contactInfo = [
    {
      id: 1,
      img: "/assests/img/location.svg",
      label: "Headquarters",
      content: "Vijay Nagar, Indore",
      details: " AB Road, Indore, M.P. - 452010"
    },
    {
      id: 2,
      img: "/assests/img/phone.svg",
      label: "Phone",
      content: "+91 808 437 8326",
      secondary: "+91 829 205 0483"
    },
    {
      id: 3,
      img: "/assests/img/mail.svg",
      label: "Email",
      content: "info@foxaisr.com"
    },
  ];

  // Smooth scroll to contact details section
  const scrollToContactDetails = () => {
    const contactSection = document.getElementById('contact-details-section');
    if (contactSection) {
      const targetPosition = contactSection.offsetTop;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeOutCubic(Math.min(timeElapsed, 800) / 800);
        window.scrollTo(0, startPosition + distance * run);
        if (timeElapsed < 800) requestAnimationFrame(animation);
      };

      requestAnimationFrame(animation);
    }
  };

  // Easing function for smooth scroll
  const easeOutCubic = (t) => {
    return 1 - Math.pow(1 - t, 3);
  };

  return (
    <div className="container-fluid contacts-container p-0">
      {/* ========== HERO SECTION START (Same as Careers) ========== */}
      <section className="contacts-hero-section">
        <div className="container contacts-hero-container mt-5">
          <h1 className="contacts-hero-title">Get in touch with us.</h1>
          <p className="contacts-hero-description">
            We're here to lead you into the future of the digital world.
            Get in touch with us to explore how Foxaisr can empower your business to thrive in today's dynamic market landscape.
          </p>
          <button className="contacts-hero-arrow-down" onClick={scrollToContactDetails} aria-label="Scroll to contact details">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
        </div>
      </section>
      {/* ========== HERO SECTION END ========== */}

      {/* Contact Details Section with Image */}
      <div id="contact-details-section">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side - Stacked Cards */}
            <div className="col-lg-6 col-md-12">
              <div className="contact-cards-stack">
                {contactInfo.map((item) => (
                  <div className="contact-card" key={item.id}>
                    <div className="contact-card-icon">
                      <img src={item.img} alt={item.label} />
                    </div>
                    <div className="contact-card-content">
                      <h3 className="contact-card-label">{item.label}</h3>
                      {item.label === "Phone" ? (
                        <>
                          <p className="contact-card-main">
                            <a href={`tel:${item.content.replace(/\s+/g, '')}`}>{item.content}</a>
                          </p>
                          {item.secondary && (
                            <p className="contact-card-main">
                              <a href={`tel:${item.secondary.replace(/\s+/g, '')}`}>{item.secondary}</a>
                            </p>
                          )}
                        </>
                      ) : item.label === "Email" ? (
                        <p className="contact-card-main">
                          <a
                            href={`mailto:${item.content.trim()}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.content}
                          </a>
                        </p>
                      ) : (
                        <p className="contact-card-main">{item.content}</p>
                      )}
                      {item.details && <p className="contact-card-sub">{item.details}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="col-lg-6 col-md-12 text-center">
              <div className="contact-image-wrapper">
                <img
                  src="/assests/img/Contact us-bro 1.svg"
                  className="img-fluid contact-illustration"
                  alt="Contact Us Illustration"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;